import React from "react";
import { Link } from "react-router-dom";
import './NotFoundPage.css';
import {IoMdHome} from "react-icons/io";

const SuccessPage = () => {


    return (
        <div style={{
            background: 'linear-gradient(to right, #76b852, #8DC26F)'
        }} className="not-found-container">
            <div className="not-found-content">
                <p className="not-found-description">
                    განაცხადი წარმატებით აიტვირთა!
                </p>
                <p className="suggestion">
                    დამატებით ინფორმაციისთვის შეამოწმეთ ელ-ფოსტა ან შეამოწმეთ თქვენი განაცხადების გვერდი!
                </p>
                <Link to={"/"} className="home-button">
                    <IoMdHome/> მთავარი გვერდი
                </Link>

            </div>
        </div>
    );
};

export default SuccessPage;
